import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { apiError } from "../../../helpers/ErrorHelper";
import { useAuth } from "../../../context/AuthContext";
import { removeCreditNote } from "../../../models/CreditNoteModel";
import { useNotificationCount } from "../../../context/NotificationCountContext";

const DeleteCreditNoteModal = ({
  showModal,
  setShowModal,
  creditNoteData,
  modalKey,
  fetchCreditNotes,
  limit,
  page,
  curr_client_id,
}) => {
  const { setNotificationCount } = useNotificationCount();
  const navigate = useNavigate();
  const { state } = useAuth();
  const user_data = state.user_data;
  const loader = document.getElementById("loading");
  const [loading, setLoading] = useState(false);
  const [credit_note_unique_id, setCreditNoteUniqueID] = useState("");

  const closeModal = () => {
    setCreditNoteUniqueID("");
    setShowModal(false);
  };

  useEffect(() => {
    if (creditNoteData) {
      setCreditNoteUniqueID(creditNoteData.credit_note_unique_id);
    }
  }, [creditNoteData, modalKey]);

  const deleteCreditNote = async () => {
    loader.style.display = "block";
    try {
      const response = await removeCreditNote(
        user_data.user_token,
        credit_note_unique_id
      );
      if (response.status) {
        toast.success(response.message);
        closeModal();
        fetchCreditNotes(limit, page, curr_client_id);
        setNotificationCount(localStorage.getItem("unread_notification_count"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);
      if (error.response?.data?.invalid_token === 1) {
        navigate("/re-login");
      }
    }
    loader.style.display = "none";
    setLoading(false);
  };

  return (
    <Modal show={showModal} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete credit note</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Delete credit note{" "}
        <strong>{creditNoteData?.credit_note_number}</strong>? This cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={closeModal}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={deleteCreditNote}
          disabled={loading}
        >
          {loading ? "Deleting…" : "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCreditNoteModal;
